<template>
  <div class="moo-sheet-head">
    <div class="moo-sheet-head__title-row">
      <span class="material-icons-round moo-sheet-head__icon">{{ icon }}</span>
      <h1 class="moo-sheet-head__title">{{ title }}</h1>
    </div>
    <button
      class="moo-sheet-head__close"
      type="button"
      aria-label="Close"
      @click="$emit('close')"
    >
      <span class="material-icons-round">close</span>
    </button>
  </div>
</template>

<script>
// The header every MOO sheet screen repeats: brand icon, title, round close
// button. Was copy-pasted into TopUp, MyTransactions, LoyaltyTierBenefit and
// GetMemberShip, each with its own token prefix for the same colours.
export default {
  name: "MooSheetHead",
  props: {
    icon: { type: String, default: "" },
    title: { type: String, default: "" },
  },
  emits: ["close"],
};
</script>

<style scoped>
.moo-sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 20px;
}
.moo-sheet-head__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.moo-sheet-head__icon {
  color: var(--sheet);
  font-size: 1.375rem;
}
.moo-sheet-head__title {
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 0;
  color: #241a12;
}
.moo-sheet-head__close {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9999px;
  border: none;
  background: var(--sheet-inset);
  color: #6b6868;
  cursor: pointer;
}
.moo-sheet-head__close .material-icons-round {
  font-size: 18px;
  line-height: 1;
}
</style>
